import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@tn-equis/core/services';
import { EquisServicesModule, EquisDocumentService, EquisNavigatorService, EquisWindowService } from '@tn-equis/core/services';
import * as i4 from '@tn-equis/core/directives';
import { EquisDirectiveModule } from '@tn-equis/core/directives';
import { Subscription } from 'rxjs';
import '@tn-equis/core/utils';
import { EquisOverlayComponent, EquisOverlayModule } from '@tn-equis/core/components/overlay';

var EquisDrawerSize;
(function (EquisDrawerSize) {
    EquisDrawerSize["EXTRA_SMALL"] = "extra-small";
    EquisDrawerSize["SMALL"] = "small";
    EquisDrawerSize["MEDIUM"] = "medium";
    EquisDrawerSize["LARGE"] = "large";
})(EquisDrawerSize || (EquisDrawerSize = {}));
var EquisDrawerSide;
(function (EquisDrawerSide) {
    EquisDrawerSide["LEFT"] = "left";
    EquisDrawerSide["RIGHT"] = "right";
})(EquisDrawerSide || (EquisDrawerSide = {}));

class EquisDrawerService {
    constructor(componentInsertionService, windowScrollService) {
        this.componentInsertionService = componentInsertionService;
        this.windowScrollService = windowScrollService;
    }
    showOverlay() {
        this._overlayId = this.componentInsertionService.create(EquisOverlayComponent, document.body);
        this.windowScrollService.disable();
    }
    closeOverlay() {
        if (this._overlayId) {
            this.componentInsertionService.destroy(this._overlayId);
            this._overlayId = null;
            this.windowScrollService.enable();
        }
    }
}
EquisDrawerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerService, deps: [{ token: i1.EquisComponentInsertionService }, { token: i1.EquisWindowScrollingService }], target: i0.ɵɵFactoryTarget.Injectable });
EquisDrawerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.EquisComponentInsertionService }, { type: i1.EquisWindowScrollingService }]; } });

class EquisDrawerHeaderComponent {
    constructor() {
        this.drawerHeaderEvents = new EventEmitter();
    }
    closeDrawer() {
        this.drawerHeaderEvents.emit();
    }
}
EquisDrawerHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisDrawerHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisDrawerHeaderComponent, selector: "z-drawer-header, equis-drawer-header", inputs: { data: "data", side: "side" }, outputs: { drawerHeaderEvents: "drawerHeaderEvents" }, ngImport: i0, template: "<header class=\"drawer__header drawer__header--shadow\">\n  <div [ngClass]=\"'drawer__header--' + side\">\n    <div\n      class=\"drawer__icon icon\"\n      [ngClass]=\"'drawer__icon--' + side\"\n      (click)=\"closeDrawer()\"\n    >\n      <span class=\"icon-cross size-24\"></span>\n    </div>\n    <h1 class=\"drawer__title\">\n      {{ data?.title }}\n    </h1>\n  </div>\n</header>\n", styles: [".drawer__header{display:flex;padding:24px;position:relative}.drawer__header--shadow:after{border-radius:0;bottom:-16px;content:\"\";height:16px;left:0;pointer-events:none;position:absolute;width:100%}.drawer__header--left{width:100%}.drawer__header--right{display:contents}.drawer__title{color:#333;font-family:Gibson-Regular,sans-serif;font-size:18px;line-height:24px}.drawer__icon{color:#333;cursor:pointer}.drawer__icon--left{float:right}.drawer__icon--right{height:24px;margin-right:16px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-drawer-header, equis-drawer-header', template: "<header class=\"drawer__header drawer__header--shadow\">\n  <div [ngClass]=\"'drawer__header--' + side\">\n    <div\n      class=\"drawer__icon icon\"\n      [ngClass]=\"'drawer__icon--' + side\"\n      (click)=\"closeDrawer()\"\n    >\n      <span class=\"icon-cross size-24\"></span>\n    </div>\n    <h1 class=\"drawer__title\">\n      {{ data?.title }}\n    </h1>\n  </div>\n</header>\n", styles: [".drawer__header{display:flex;padding:24px;position:relative}.drawer__header--shadow:after{border-radius:0;bottom:-16px;content:\"\";height:16px;left:0;pointer-events:none;position:absolute;width:100%}.drawer__header--left{width:100%}.drawer__header--right{display:contents}.drawer__title{color:#333;font-family:Gibson-Regular,sans-serif;font-size:18px;line-height:24px}.drawer__icon{color:#333;cursor:pointer}.drawer__icon--left{float:right}.drawer__icon--right{height:24px;margin-right:16px}\n"] }]
        }], propDecorators: { data: [{
                type: Input
            }], side: [{
                type: Input
            }], drawerHeaderEvents: [{
                type: Output
            }] } });

class EquisDrawerBodyComponent {
}
EquisDrawerBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisDrawerBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisDrawerBodyComponent, selector: "z-drawer-body, equis-drawer-body", ngImport: i0, template: "<div class=\"drawer__body\">\n  <ng-content select=\"[body]\"></ng-content>\n</div>\n", styles: [".drawer__body{padding:8px 24px 32px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-drawer-body, equis-drawer-body', template: "<div class=\"drawer__body\">\n  <ng-content select=\"[body]\"></ng-content>\n</div>\n", styles: [".drawer__body{padding:8px 24px 32px}\n"] }]
        }] });

class EquisDrawerComponent {
    constructor(drawerService, keypressService) {
        this.drawerService = drawerService;
        this.keypressService = keypressService;
        this.drawerEvents = new EventEmitter();
        this.firstRender = true;
        this.drawerSize = EquisDrawerSize.MEDIUM;
        this.drawerSide = EquisDrawerSide.LEFT;
        this._showDrawer = false;
        this.closeAnimation = 250;
        this.outerClickElement = 'overlay';
        this.keypressService$ = new Subscription();
        // Reservados, para cuando el usuario pueda ingresarlos como input, que los tome automáticamente
        this.closeOnEscKey = true;
        this.closeOnBackgroundClick = true;
    }
    set show(show) {
        if (!!show !== this._showDrawer) {
            this.firstRender = false;
            this._showDrawer = show;
            this.drawerEvents.emit(this._showDrawer);
            // Se agrega el timeout ya que sino genera error al captar los cambios visuales en el componente overlay
            setTimeout(() => {
                this.toggleOverlay();
            }, 0);
        }
    }
    get show() {
        return this._showDrawer;
    }
    set size(size) {
        this.drawerSize = Object.values(EquisDrawerSize).includes(size)
            ? size
            : EquisDrawerSize.MEDIUM;
    }
    set side(side) {
        this.drawerSide = Object.values(EquisDrawerSide).includes(side)
            ? side
            : EquisDrawerSide.LEFT;
    }
    ngOnInit() {
        this.keypressService$ = this.keypressService
            .keyPressEscape()
            .subscribe((escapePressed) => {
            if (this.closeOnEscKey && escapePressed === true && this.show) {
                this.closeDrawer();
            }
        });
    }
    closeDrawer() {
        this.show = false;
        this.scrollToTop();
    }
    toggleDrawer() {
        this.show = !this.show;
        if (!this.show) {
            this.scrollToTop();
        }
    }
    toggleOverlay() {
        this.show
            ? this.drawerService.showOverlay()
            : this.drawerService.closeOverlay();
    }
    scrollToTop() {
        // Espera 250ms por la animación de cierre.
        setTimeout(() => {
            this.drawerBody.nativeElement.scrollTop = 0;
        }, this.closeAnimation);
    }
    drawerClickOutside(targetElement) {
        if (this.closeOnBackgroundClick &&
            targetElement.className === this.outerClickElement) {
            this.closeDrawer();
        }
    }
    ngOnDestroy() {
        if (this.keypressService$) {
            this.keypressService$.unsubscribe();
        }
    }
}
EquisDrawerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerComponent, deps: [{ token: EquisDrawerService }, { token: i1.EquisKeypressService }], target: i0.ɵɵFactoryTarget.Component });
EquisDrawerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisDrawerComponent, selector: "z-drawer, equis-drawer", inputs: { show: "show", drawerData: "drawerData", size: "size", side: "side" }, outputs: { drawerEvents: "drawerEvents" }, viewQueries: [{ propertyName: "drawerBody", first: true, predicate: ["drawerBody"], descendants: true, static: true }], ngImport: i0, template: "<nav class=\"drawer\" EquisOuterClick (clickOutside)=\"drawerClickOutside($event)\">\n  <div\n    class=\"drawer__container\"\n    [ngClass]=\"[\n      firstRender ? '' : 'drawer__container--animate',\n      show ? 'drawer__container--show' : '',\n      'drawer__container--' + drawerSize,\n      'drawer__container--' + drawerSide\n    ]\"\n  >\n    <equis-drawer-header\n      [id]=\"drawerData?.header?.id\"\n      [data]=\"drawerData?.header\"\n      [side]=\"drawerSide\"\n      (drawerHeaderEvents)=\"closeDrawer()\"\n    >\n    </equis-drawer-header>\n\n    <div class=\"drawer__body\" #drawerBody>\n      <equis-drawer-body [id]=\"drawerData?.body?.id\">\n        <ng-content select=\"[body]\" body></ng-content>\n      </equis-drawer-body>\n    </div>\n\n    <footer class=\"drawer__footer\" [id]=\"drawerData?.footer?.id\">\n      <ng-content select=\"[footer]\"></ng-content>\n    </footer>\n  </div>\n</nav>\n", styles: [".drawer__body{height:100%;overflow-x:hidden;overflow-y:auto}.drawer__container{background-color:#fff;display:flex;flex-direction:column;height:100%;left:0;position:fixed;top:0;transform:translate(-100%);width:calc(100% - 48px);z-index:810}.drawer__container--extra-small{max-width:408px}.drawer__container--small{max-width:648px}.drawer__container--medium{max-width:968px}.drawer__container--right{left:auto;right:0;transform:translate(100%)}.drawer__container--animate{transition:transform .25s ease-in-out}.drawer__container--show{transform:translate(0)}.drawer__footer{padding:24px 0}.drawer__footer:empty{display:none}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i4.EquisOuterClickDirective, selector: "[zOuterClick], [EquisOuterClick]", inputs: ["disabledClose"], outputs: ["clickOutside"], exportAs: ["zOuterClick", "EquisOuterClick"] }, { kind: "component", type: EquisDrawerHeaderComponent, selector: "z-drawer-header, equis-drawer-header", inputs: ["data", "side"], outputs: ["drawerHeaderEvents"] }, { kind: "component", type: EquisDrawerBodyComponent, selector: "z-drawer-body, equis-drawer-body" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-drawer, equis-drawer', template: "<nav class=\"drawer\" EquisOuterClick (clickOutside)=\"drawerClickOutside($event)\">\n  <div\n    class=\"drawer__container\"\n    [ngClass]=\"[\n      firstRender ? '' : 'drawer__container--animate',\n      show ? 'drawer__container--show' : '',\n      'drawer__container--' + drawerSize,\n      'drawer__container--' + drawerSide\n    ]\"\n  >\n    <equis-drawer-header\n      [id]=\"drawerData?.header?.id\"\n      [data]=\"drawerData?.header\"\n      [side]=\"drawerSide\"\n      (drawerHeaderEvents)=\"closeDrawer()\"\n    >\n    </equis-drawer-header>\n\n    <div class=\"drawer__body\" #drawerBody>\n      <equis-drawer-body [id]=\"drawerData?.body?.id\">\n        <ng-content select=\"[body]\" body></ng-content>\n      </equis-drawer-body>\n    </div>\n\n    <footer class=\"drawer__footer\" [id]=\"drawerData?.footer?.id\">\n      <ng-content select=\"[footer]\"></ng-content>\n    </footer>\n  </div>\n</nav>\n", styles: [".drawer__body{height:100%;overflow-x:hidden;overflow-y:auto}.drawer__container{background-color:#fff;display:flex;flex-direction:column;height:100%;left:0;position:fixed;top:0;transform:translate(-100%);width:calc(100% - 48px);z-index:810}.drawer__container--extra-small{max-width:408px}.drawer__container--small{max-width:648px}.drawer__container--medium{max-width:968px}.drawer__container--right{left:auto;right:0;transform:translate(100%)}.drawer__container--animate{transition:transform .25s ease-in-out}.drawer__container--show{transform:translate(0)}.drawer__footer{padding:24px 0}.drawer__footer:empty{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: EquisDrawerService }, { type: i1.EquisKeypressService }]; }, propDecorators: { show: [{
                type: Input
            }], drawerData: [{
                type: Input
            }], size: [{
                type: Input
            }], side: [{
                type: Input
            }], drawerEvents: [{
                type: Output
            }], drawerBody: [{
                type: ViewChild,
                args: ['drawerBody', { static: true }]
            }] } });

class EquisDrawerHeaderModule {
    static forRoot() {
        return {
            ngModule: EquisDrawerHeaderModule,
        };
    }
}
EquisDrawerHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisDrawerHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerHeaderModule, declarations: [EquisDrawerHeaderComponent], imports: [CommonModule], exports: [EquisDrawerHeaderComponent] });
EquisDrawerHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerHeaderModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisDrawerHeaderComponent],
                    imports: [CommonModule],
                    exports: [EquisDrawerHeaderComponent],
                }]
        }] });

class EquisDrawerBodyModule {
    static forRoot() {
        return {
            ngModule: EquisDrawerBodyModule,
        };
    }
}
EquisDrawerBodyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerBodyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisDrawerBodyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerBodyModule, declarations: [EquisDrawerBodyComponent], imports: [CommonModule], exports: [EquisDrawerBodyComponent] });
EquisDrawerBodyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerBodyModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerBodyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisDrawerBodyComponent],
                    imports: [CommonModule],
                    exports: [EquisDrawerBodyComponent],
                }]
        }] });

class EquisDrawerComponentModule {
    static forRoot() {
        return {
            ngModule: EquisDrawerComponentModule,
        };
    }
}
EquisDrawerComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisDrawerComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerComponentModule, declarations: [EquisDrawerComponent], imports: [CommonModule,
        EquisDirectiveModule,
        EquisDrawerHeaderModule,
        EquisDrawerBodyModule], exports: [EquisDrawerComponent] });
EquisDrawerComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerComponentModule, providers: [
        EquisDrawerService,
        EquisServicesModule,
        EquisDocumentService,
        EquisNavigatorService,
        EquisWindowService,
    ], imports: [CommonModule,
        EquisDirectiveModule,
        EquisDrawerHeaderModule,
        EquisDrawerBodyModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisDrawerComponent],
                    imports: [
                        CommonModule,
                        EquisDirectiveModule,
                        EquisDrawerHeaderModule,
                        EquisDrawerBodyModule,
                    ],
                    exports: [EquisDrawerComponent],
                    providers: [
                        EquisDrawerService,
                        EquisServicesModule,
                        EquisDocumentService,
                        EquisNavigatorService,
                        EquisWindowService,
                    ],
                }]
        }] });

class EquisDrawerModule {
    static forRoot() {
        return {
            ngModule: EquisDrawerModule,
        };
    }
}
EquisDrawerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisDrawerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerModule, imports: [EquisOverlayModule, EquisDrawerComponentModule], exports: [EquisDrawerComponentModule] });
EquisDrawerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerModule, imports: [EquisOverlayModule, EquisDrawerComponentModule, EquisDrawerComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisDrawerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EquisOverlayModule, EquisDrawerComponentModule],
                    exports: [EquisDrawerComponentModule],
                }]
        }] });

/*
 * Public API Surface of equis-drawer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisDrawerBodyComponent, EquisDrawerBodyModule, EquisDrawerComponent, EquisDrawerComponentModule, EquisDrawerHeaderComponent, EquisDrawerHeaderModule, EquisDrawerModule, EquisDrawerService, EquisDrawerSide, EquisDrawerSize };
